import React from 'react'
import Geosuggest from 'react-geosuggest'
import {FormField} from '@cred/react-form-field'
import {Label} from '@cred/react-label'

const GeosuggestComponent = ({
  input,
  label,
  meta,
  placeholder,
  handleSelect,
  autoComplete,
  forwardRef
}) =>
    <FormField status={meta} label={label} error={meta.error} value={input.value}>
      <Geosuggest
        ref={forwardRef}
        inputClassName="InspectletIgnore"
        autoComplete={autoComplete}
        onSuggestSelect={handleSelect}
        placeholder={placeholder}
        country="us"
        autoActivateFirstSuggest={true}
        initialValue={input.value}
        {...input}
      />
      <Label>{label}</Label>
    </FormField>

export {GeosuggestComponent}
